import {useState} from 'react'
import {ProductGroup, createProductGroup, editProductGroup} from './api'
import {useLayout} from '../../../../_metronic/layout/core'
import Select from 'react-select'
import {KTIcon, OptionType} from '../../../../_metronic/helpers'
import toast from 'react-hot-toast'
import {removeIndicatorSeparator, solidSelectStyles} from '../../shared/ui/selectStyles'

const classificationMap: Record<string, string> = {
  'Current Liabilities': 'Liabilities',
  'Non-Current Liabilities': 'Liabilities',
  'Current Assets': 'Assets',
  'Non-Current Assets': 'Assets',
  'Direct Expenses': 'Expenses',
  'Indirect Expenses': 'Expenses',
  'Direct Income': 'Incomes',
  'Indirect Income': 'Incomes',
  Equity: 'Liabilities',
}

const parentGroups = [
  {
    value: '',
    label: 'Select a Parent Group...',
  },
  {
    label: 'Current Liabilities',
    value: 'Current Liabilities',
  },
  {
    label: 'Current Assets',
    value: 'Current Assets',
  },
  {
    label: 'Non-Current Assets',
    value: 'Non-Current Assets',
  },
  {
    label: 'Non-Current Liabilities',
    value: 'Non-Current Liabilities',
  },
  {
    label: 'Direct Expenses',
    value: 'Direct Expenses',
  },
  {
    label: 'Indirect Expenses',
    value: 'Indirect Expenses',
  },
  {
    label: 'Direct Income',
    value: 'Direct Income',
  },
  {
    label: 'Indirect Income',
    value: 'Indirect Income',
  },
  {
    label: 'Equity',
    value: 'Equity',
  },
]
const validateSubGroup = (value: string) => {
  const regex = /^(?!.*\bnone\b)[a-zA-Z0-9-' ]{1,25}$/
  return regex.test(value)
}
export const CreateEditGroup: React.FC<{
  setCreateGroup: React.Dispatch<React.SetStateAction<boolean>>
  editGroup?: ProductGroup
  setShouldRefreshGroups: React.Dispatch<React.SetStateAction<boolean>>
}> = ({setCreateGroup, editGroup, setShouldRefreshGroups}) => {
  const {company} = useLayout()
  const [loading, setLoading] = useState(false)
  const [subGroup, setSubGroup] = useState(editGroup?.subGroup ? editGroup.subGroup : '')
  const [subGroupError, setSubGroupError] = useState<string>('')

  const [parentGroup, setParentGroup] = useState(
    editGroup
      ? {value: editGroup.parentGroup, label: editGroup.parentGroup}
      : {
          value: '',
          label: 'Select a Parent Group...',
        }
  )
  const validateAndSetSubGroup = (value: string) => {
    setSubGroup(value)

    if (!value) {
      setSubGroupError('Group name is required')
    } else if (!validateSubGroup(value)) {
      if (value.length > 25) {
        setSubGroupError('Group name cannot exceed 25 characters')
      } else if (value.toLowerCase().includes('none')) {
        setSubGroupError('Group name cannot contain the word "none"')
      } else {
        setSubGroupError(
          'Group name can only contain letters, numbers, hyphens, apostrophes and spaces'
        )
      }
    } else {
      setSubGroupError('')
    }
  }
  const handleCreateNewGroup = async () => {
    // Validate before submission
    if (!validateSubGroup(subGroup)) {
      return
    }
    setLoading(true)
    if (!editGroup?.groupId)
      createProductGroup({
        // group_id: editGroup?.dbId,
        parent_group: parentGroup.value,
        classification: classificationMap[parentGroup.value] || '',
        company_id: company?.value || '',
        sub_group: subGroup,
        is_parent_group: editGroup?.isParentGroup,
        is_default_group: editGroup?.isDefaultGroup,
      })
        .then((res) => {
          res?.detail && toast.success(res.detail)
          setSubGroup('')
          setParentGroup({
            value: '',
            label: 'Select a Parent Group...',
          })
          setShouldRefreshGroups(true)
        })
        .catch((err) => err && toast.error(err))
        .finally(() => {
          setLoading(false)
          setCreateGroup(false)
        })
    else
      editProductGroup({
        group_id: editGroup?.groupId,
        parent_group: parentGroup.value,
        classification: classificationMap[parentGroup.value] || '',
        company_id: company?.value || '',
        sub_group: subGroup,
        is_parent_group: editGroup?.isParentGroup,
        is_default_group: editGroup?.isDefaultGroup,
      })
        .then((res) => {
          res?.detail && toast.success(res.detail)
          setSubGroup('')
          setParentGroup({
            value: '',
            label: 'Select a Parent Group...',
          })

          setShouldRefreshGroups(true)
        })
        .catch((err) => err && toast.error(err))
        .finally(() => {
          setLoading(false)
          setCreateGroup(false)
        })
  }

  return (
    <div className='card'>
      <div
        className='card-header border-0'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{!!editGroup ? 'Update Group' : 'Add New Group'}</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Parent Group</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <Select
                // {...formik.getFieldProps('reportingCurrency')}
                value={parentGroup}
                onChange={(option: any) => setParentGroup(option as OptionType)}
                options={parentGroups}
                isSearchable={true}
                className={'fw-bold'}
                styles={solidSelectStyles}
                components={removeIndicatorSeparator}
              />
            </div>
          </div>

          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Group Name</label>

            <div className='col-lg-8 fv-row'>
              <input
                type='text'
                className={`form-control form-control-lg form-control-solid ${
                  subGroupError ? 'is-invalid' : ''
                }`}
                placeholder='Group name'
                value={subGroup}
                onChange={(e) => validateAndSetSubGroup(e.target.value)}
              />
              {subGroupError && <div className='invalid-feedback d-block'>{subGroupError}</div>}
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            className='btn btn-secondary'
            style={{marginRight: '10px'}}
            onClick={() => {
              setCreateGroup(false)
              setShouldRefreshGroups(false)
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleCreateNewGroup}
            className='btn btn-primary ml-2'
            disabled={loading || !parentGroup.value || !subGroup.length || !!subGroupError}
          >
            {!loading && !!editGroup ? 'Save Group' : 'Add Group'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
